import { createFileRoute } from '@tanstack/react-router';
import { ProjectEditPage } from '@/pages/projects/ui/ProjectEditPage';

export const Route = createFileRoute('/_protected/projects/$projectId/edit')({
  component: ProjectEditPage,
});
